import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav className="navbar">
      <h1>BlogLab</h1>
      <div className="links">
        <Link to="/">Home</Link>
        <Link
          to="/create"
          // Inline styling
          style={{
            color: "white",
            //  #f1356d
            backgroundColor: "#f1356d",
            borderRadius: "8px",
          }}
        >
          New Blog
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
